<template>
	 <div class="registrations-container">
		<div class="registrations-main">
			<div class="registration-title">
				<h2 class="text-dark text-thin">{{ this.modelTitle }}</h2>
			</div>
			
			<hr class="mb-3" />

			<div class="d-flex justify-content-between align-items-center">
				<ul class="nav gap1">
					<li>
						<div class="dropdown dropdown-demo ">
							<a href="#" class="dd-link" data-toggle="dropdown">
								<div v-if="filter.processReference !== ''">
									<span class="mg-l-0 pd-l-0"> 
										<i class="icon ion-person-stalker tx-indigo mg-r-5"></i>Referência do Processo:
										<span class="pd-x-5 badge badge-indigo mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.processReference }}
										</span>
										<i class="fa fa-angle-down mg-l-5"></i>
										<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.processReference = ''"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="icon ion-person-stalker mg-r-5"></i> Referência do Processo: </span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>

							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Referência do Processo
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Digite a referência do processo
								</p>
								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label">
													Referência do Processo
												</label>
												<input 
													type="text" 
													class="form-control" 
													v-model="filter.processReference"
													@input="filterProcessReference"
													@keypress="onlyNumbers"
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo">
							<a href="#" class="dd-link" data-toggle="dropdown">
								<div v-if="filter.date.start !== '' && filter.date.end !== '' && (filter.date.field || filter.date.field?.value)">
									<span class="mg-l-0 pd-l-0">
										<i class="fa fa-calendar tx-info"></i> Período:
										<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.date.field.label }} de
											{{ filter.date.start | moment("DD/MM/YYYY") }} até
											{{ filter.date.end | moment("DD/MM/YYYY") }}
										</span>
										<i class="fa fa-angle-down mg-l-5"></i>
										<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.date = { start: '', end: '', field: '' }"></i>
									</span>
								</div>
								<div v-else>
									<span> <i class="fa fa-calendar mg-r-5"></i> Período</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Data do Período dos Processos
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione um campo e uma data inicial e final
								</p>
								<div class="form-layout form-layout-2 modify">
									<div class="row no-gutters">
										<div class="col-md-6">
											<div class="form-group">
												<label class="form-control-label">Data Inicial <span class="tx-danger">*</span></label>
												<date-picker 
													lang="pt-br" 
													v-model="filter.date.start" 
													name="toPickedDate"
													format="DD/MM/YYYY"
													placeholder="Data Inicial"
												/>
											</div>
										</div>
										<div class="col-md-6 mg-t--1 mg-md-t-0">
											<div class="form-group mg-md-l--1">
												<label class="form-control-label">Data Final <span class="tx-danger">*</span></label>
												<date-picker 
													lang="pt-br"
													v-model="filter.date.end"
													name="toPickedDate"
													format="DD/MM/YYYY"
													placeholder="Data Final"
												/>
											</div>
										</div>
									</div>
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group bd-t-0-force">
												<label class="form-control-label">Campo do Filtro</label>
												<v-select
													v-model="filter.date.field"
													:options="listOfDatesFields"
													name="label"
												>
													<template slot="option" slot-scope="option">
														{{ option.label }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link tx-light" data-toggle="dropdown">
								<div v-if="filter.customerId !== null">
									<span class="mg-l-0 pd-l-0">
										<i class="fa fa-building tx-danger mg-r-5"></i>Clientes:
										<span class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.customerId.name }}
										</span>
										<i class="fa fa-angle-down mg-l-5"></i>
										<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.customerId = null"></i>
									</span>
								</div>

								<div v-else>
									<span><i class="fa fa-building tx-medium mg-r-5"></i> Clientes</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Clientes
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione um cliente ({{ this.listOfCustomers.length }} encontrados)
								</p>

								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label"> Clientes </label>
												<v-select
													v-model="filter.customerId"
													label="name"
													:options="listOfCustomers"
													name="customerId"
												>
													<template slot="option" slot-scope="option">
														{{ option.name }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link" data-toggle="dropdown">
								<div v-if="filter.teams.length > 0">
									<span class="mg-l-0 pd-l-0">
										<i class="icon ion-person-stalker tx-pink mg-r-5"></i>Equipes:
										<span class="pd-x-5 badge badge-pink mg-b-0 mg-r-2-force tx-thin-force" v-for="t in filter.teams" :key="t.id" style="margin-right: 5px !important;">
											{{ t.name }} <i class="fa fa-times mg-l-5" @click.stop.prevent="filter.teams = filter.teams.filter(team => team.id !== t.id)"></i>
										</span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="icon ion-person-stalker tx-medium mg-r-5"></i>Equipes</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>

							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-0">
									Equipe
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione um ou mais Equipes ({{ this.listOfTeams.length }}
									encontrados)
								</p>

								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label"> Equipes </label>
												<v-select
													v-model="filter.teams"
													label="name"
													:options="listOfTeams"
													name="teams"
													multiple
												>
													<template slot="option" slot-scope="option">
														{{ option.name }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link tx-light" data-toggle="dropdown">
								<div v-if="filter.isSowport !== null && (filter.isSowport?.value === true || filter.isSowport?.value === false)">
									<span class="mg-l-0 pd-l-0">
									<i class="fa fa-flag tx-info mg-r-5"></i>Respondido:
										<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.isSowport?.value === true ? 'Sowport' : 'Prime' }}
										</span>
									<i class="fa fa-angle-down mg-l-5"></i>
									<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.isSowport = null"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="fa fa-flag tx-medium mg-r-5"></i> Importado por</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Importado por
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione para filtrar se o NPS foi importado pela Prime ou Sowport
								</p>
								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label"> Importado por </label>
												<v-select
													v-model="filter.isSowport"
													label="label"
													:options="listOfIsSowport"
													name="isSowport"
												>
													<template slot="option" slot-scope="option">
														{{ option.label }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link tx-light" data-toggle="dropdown">
								<div v-if="filter.score.min !== null && filter.score.max !== null">
									<span class="mg-l-0 pd-l-0">
										<i class="fa fa-star tx-teal mg-r-5"></i>Notas:
										<span class="pd-x-5 badge badge-teal mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.score.min }} até {{ filter.score.max }}
										</span>
										<i class="fa fa-angle-down mg-l-5"></i>
										<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.score = { min: null, max: null }"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="fa fa-star tx-medium mg-r-5"></i> Notas</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Notas
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione uma nota mínima e uma nota máxima
								</p>

								<div class="form-layout form-layout-2 modify">
									<div class="row no-gutters">
										<div class="col-md-6">
											<div class="form-group">
												<label class="form-control-label">Nota Mínimo <span class="tx-danger">*</span></label>
												<input type="number" min="1" max="10" class="form-control" v-model="filter.score.min" @input="validateScoreInput('min')" placeholder="Nota Mínimo">
											</div>
										</div>
										<div class="col-md-6 mg-t--1 mg-md-t-0">
											<div class="form-group mg-md-l--1">
												<label class="form-control-label">Nota Máxima <span class="tx-danger">*</span></label>
												<input type="number" min="1" max="10" class="form-control" v-model="filter.score.max" @input="validateScoreInput('max')" placeholder="Nota Máxima">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link tx-light" data-toggle="dropdown">
								<div v-if="filter.isAnswered !== null && (filter.isAnswered?.value === true || filter.isAnswered?.value === false)">
									<span class="mg-l-0 pd-l-0">
									<i class="fa fa-flag tx-info mg-r-5"></i>Respondido:
										<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.isAnswered?.value === true ? 'Sim' : 'Não' }}
										</span>
									<i class="fa fa-angle-down mg-l-5"></i>
									<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.isAnswered = null"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="fa fa-flag tx-medium mg-r-5"></i> Respondido</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Respondido
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione para filtrar se o NPS foi respondido ou não
								</p>
								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label"> Respondido </label>
												<v-select
													v-model="filter.isAnswered"
													label="label"
													:options="listOfIsAnswered"
													name="isAnswered"
												>
													<template slot="option" slot-scope="option">
														{{ option.label }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link tx-light" data-toggle="dropdown">
								<div v-if="filter.emailViewed !== null">
									<span class="mg-l-0 pd-l-0">
									<i class="fa fa-envelope tx-info mg-r-5"></i>E-mail lido:
										<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.emailViewed.value === true ? 'Sim' : 'Não' }}
										</span>
										<i class="fa fa-angle-down mg-l-5"></i>
										<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.emailViewed = null"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="fa fa-envelope tx-medium mg-r-5"></i> E-mail lido</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									E-mail lido
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione para filtrar se o e-mail foi lido ou não
								</p>
								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label"> E-mail lido </label>
												<v-select
													v-model="filter.emailViewed"
													label="label"
													:options="listOfEmailViewed"
													name="emailViewed"	
												>
													<template slot="option" slot-scope="option">
														{{ option.label }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div class="dropdown dropdown-demo" data-pesistent>
							<a href="#" class="dd-link tx-light" data-toggle="dropdown">
								<div v-if="filter.includeActions !== null && (filter.includeActions?.value === true || filter.includeActions?.value === false)">
									<span class="mg-l-0 pd-l-0">
									<i class="fa fa-flag tx-info mg-r-5"></i>Com ações:
										<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
											{{ filter.includeActions?.value === true ? 'Sim' : 'Não' }}
										</span>
									<i class="fa fa-angle-down mg-l-5"></i>
									<i class="fa fa-close mg-l-20" @click.stop.prevent="filter.includeActions = null"></i>
									</span>
								</div>
								<div v-else>
									<span><i class="fa fa-flag tx-medium mg-r-5"></i> Com ações</span>
									<i class="fa fa-angle-down mg-l-5"></i>
								</div>
							</a>
							<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
								<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
									Com ações
								</h6>
								<p class="tx-gray-600 mg-b-10">
									Selecione para filtrar se o NPS tem ações ou não
								</p>
								<div class="form-layout form-layout-2">
									<div class="row no-gutters">
										<div class="col-md-12">
											<div class="form-group">
												<label class="form-control-label"> Com ações </label>
												<v-select
													v-model="filter.includeActions"
													label="label"
													:options="listOfIncludeActions"
													name="includeActions"
												>
													<template slot="option" slot-scope="option">
														{{ option.label }}
													</template>
												</v-select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>

				</ul>
				<ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
					<li class="mg-l-10">
						<div class="flex ai-c gap3">
							<button type="button" class="btn-refresh" @click.prevent="clearFilter()" @mouseover="hoverClearFilter = 'white'" @mouseleave="hoverClearFilter = '#104375'">
								<ClearIcon :size="24" :color="hoverClearFilter"/>
							</button>
							<button type="button" class="crm-button" @click.prevent="getDataList(1, perPage)">
								<i class="fa fa-play mg-r-5"></i> FILTRAR
							</button>
						</div>
					</li>
				</ul>
			</div>

			<hr class="mb-4" />

			<TableSSR 
				@pageChange="getDataList($event.page, $event.perPage)"
				@searchChange="getDataList(1, $event.perPage)"
				@perPageChange="getDataList($event.page, $event.perPage)"
				:columns="tableColumns" 
				:current-page="tableData?.currentPage + 1 || tableData.currentPage + 1"
				:last-page="tableData.totalPages"
				:tableData="tableData.content"
				:totalRecords="tableData.totalElements"
				:table-config="{
					useSearch: false,
					centeredCell: false,
					showRecords: true,
					paginationTop: true,
					typeSearch: 'query',
					showPerPageTop: true,
					showPerPageBottom: true,
					perPage: tableData?.size ?? 20,
				}"
			>
				<template #processReference="{ item }">
					<div v-if="'processReference' in item">
						<a v-if="item.processReference" href="#" class="nps-process-link" @click.prevent="findProcessByIdentificationSearch(item.processReference)"> 
							{{ item.processReference }}
						</a>
						<p v-else> - </p>
					</div>
				</template>
				<template #customerName="{ item }">
					<div v-if="'customerName' in item">
						<p v-if="item.customerName"> 
							{{ item.customerName }}
						</p>
						<p v-else> - </p>
					</div>
          		</template>
				  <template #isSowport="{ item }">
					<div v-if="'isSowport' in item">
						<p v-if="item.isSowport"> 
							Sowport
						</p>
						<p v-else> Prime </p>
					</div>
          		</template>
				<template #userName="{ item }">
					<p v-if="'userName' in item" class="flex fd-c"> 
						<span class="text-color-primary">{{ item.userName }}</span>
						<small v-if="item.userEmail">{{ item.userEmail }}</small>
					</p>
					<p v-else> - </p>
				</template>
				<template #createdAt="{ item }">
					<div v-if="'createdAt' in item" class="text-center">
						<p v-if="item.createdAt"> 
							{{ item.createdAt | formatDateTimeFunction }}
						</p>
						<p v-else> - </p>
					</div>
				</template>
				<template #emailViewed="{ item }">
					<div v-if="'emailViewed' in item" class="text-center">
						<p v-if="item.emailViewed !== null"> 
							<span class="config-table-tag text-center" :class="{ success: item.emailViewed, danger: !item.emailViewed }">
								{{ item.emailViewed === true ? 'Sim' : 'Não' }}
							</span>
						</p>
						<p v-else> - </p>
					</div>
				</template>
				<template #isAnswered="{ item }">
					<div v-if="'isAnswered' in item" class="text-center">
						<span class="config-table-tag text-center" :class="{ success: item.isAnswered, danger: !item.isAnswered }">
							{{ item.isAnswered ? 'Sim' : 'Não' }}
						</span>
					</div>
				</template>
				<template #score="{ item }">
					<div v-if="'score' in item" class="text-center">
						<span v-if="item.score" class="config-table-tag text-center" :class="getScoreClass(item.score)">
							{{ item.score }}
						</span>
						<span v-else class="config-table-tag text-center nps-score-empty"> - </span>
					</div>
				</template>
				<template #answeredAt="{ item }">
					<div v-if="'answeredAt' in item" class="text-center">
						<p v-if="item.answeredAt"> 
							{{ item.answeredAt | formatDateTimeFunction }}
						</p>
						<p v-else> - </p>
					</div>
				</template>
				<template #observation="{ item }">
					<div v-if="'observation' in item && item.observation" class="text-center flex ai-c jc-c">			
						<button class="crm-button sm nps-view-button" @click="openAnswerModal(item.id)">
							<VisibilityIcon :size="18" />
						</button>
					</div>
					<div v-else class="text-center"> N/I</div>
				</template>
				<template #actions="{ item }">
					<div v-if="'isAnswered' in item && item.isAnswered === true" class="text-center flex ai-c jc-c">
						<button
							class="crm-button sm nps-view-button"
							:class="{ 'nps-view-button-gray': item.countActions === 0 || item.countActions == null }"
							@click="openAnswerModal(item.id)"
						>
							<AssignmentAddIcon :size="18" />
						</button>
					</div>
					<div v-else class="text-center"> - </div>
				</template>
			</TableSSR>

			<v-modal
				:width="1400"
				:height="55"
				:title="`NPS do processo - #${answerModalData.processReference}`"
				:handler="answerModalOpen"
				@requestClose="closeAnswerModal"
				description="Resposta da pesquisa do NPS do processo"
			>
				<template #content>
					<div class="nps-modal-content">
						<div class="nps-modal-column nps-modal-column-left">
							<!-- Score Card -->
							<div class="nps-modal-score-card">
								<div class="nps-modal-score-card-inner">
									<p class="nps-modal-score-label">Nota atribuída</p>
									<p v-if="answerModalData.score != null" class="nps-modal-score-number" :style="{ color: getScoreColor(answerModalData.score) }">
										{{ answerModalData.score }}
									</p>
									<p v-else class="nps-modal-score-number" style="color: #6c757d;">
										-
									</p>
									<p class="nps-modal-score-classification">{{ getScoreClassification(answerModalData.score) }}</p>
								</div>
							</div>

							<!-- Details -->
							<div class="nps-modal-details">
								<div class="nps-modal-detail-item">
									<strong class="nps-modal-detail-label">Processo:</strong>
									<span class="nps-modal-detail-value">{{ answerModalData.processReference }}</span>
								</div>
								<div class="nps-modal-detail-item">
									<strong class="nps-modal-detail-label">Cliente:</strong>
									<span class="nps-modal-detail-value">{{ answerModalData.customerName }}</span>
								</div>
								<div class="nps-modal-detail-item">
									<strong class="nps-modal-detail-label">Usuário:</strong>
									<span class="nps-modal-detail-value">{{ answerModalData.userName }}</span>
								</div>
								<div class="nps-modal-detail-item">
									<strong class="nps-modal-detail-label">Email:</strong>
									<span class="nps-modal-detail-value">{{ answerModalData.userEmail }}</span>
								</div>
							</div>

							<!-- Observation -->
							<div class="nps-modal-observation-section">
								<p class="nps-modal-observation-title">Observação do usuário:</p>
								<div class="nps-modal-observation-box">
									<p class="nps-modal-observation-text">
										{{ answerModalData.observation || 'Nenhuma observação informada.' }}
									</p>
								</div>
							</div>
						</div>

						<div class="nps-modal-column nps-modal-column-right">
							<div class="nps-modal-action-card">
								<p class="nps-modal-action-title">Ação a resposta do NPS</p>
								<textarea
									v-model="npsActionText"
									class="nps-modal-action-textarea"
									rows="3"
									placeholder="Digite a ação a ser tomada..."
								></textarea>
								<button type="button" class="crm-button nps-modal-action-btn" @click="addNpsAction">
									Adicionar
								</button>
							</div>
							<NpsAnswerTimeline
								ref="npsAnswerTimeline"
								:answer-id="answerModalData.id"
							/>
						</div>
					</div>
				</template>
				<template #footer>
					<div class="flex ai-c fgap1 jc-c">
						<button class="crm-button red" @click="closeAnswerModal">Fechar</button>
					</div>
				</template>
			</v-modal>
		</div>
	</div>
</template>
  
<script>

import TableSSR from "@/components/TableSSR.vue";
import Swal from "sweetalert2";
import config from "@/config";
import Axios from "axios";
import moment from 'moment';
import VModal from "@/components/VModal.vue";
import VisibilityIcon from "@/components/icons/VisibilityIcon.vue";
import DatePicker from "vue2-datepicker";
import vSelect from "vue-select";
import ClearIcon from "@/components/icons/ClearIcon.vue";
import AssignmentAddIcon from "@/components/icons/AssignmentAddIcon.vue";
import NpsAnswerTimeline from "./timeline.vue";

export default {
	name: 'RegistrationsList',
	components : {
		TableSSR,
		VModal,
		VisibilityIcon,
		DatePicker,
		vSelect,
		ClearIcon,
		AssignmentAddIcon,
		NpsAnswerTimeline,
	},
	data() {
		return {
			modelTitle: 'Listagem de NPS por processos',
			tableData: [],
			answerModalOpen: false,
			hoverClearFilter: '#104375',
			answerModalData: {},
			npsActionText: '',
			listOfCustomers: [],
			listOfTeams: [],
			perPage: 20,
			listOfScores: [
				{ label: '1', value: 1 },
				{ label: '2', value: 2 },
				{ label: '3', value: 3 },
				{ label: '4', value: 4 },
				{ label: '5', value: 5 },
				{ label: '6', value: 6 },
				{ label: '8', value: 8 },
				{ label: '9', value: 9 },
				{ label: '10', value: 10 },
			],
			listOfIsAnswered: [
				{ label: 'Sim', value: true },
				{ label: 'Não', value: false },
			],
			listOfEmailViewed: [
				{ label: 'Sim', value: true },
				{ label: 'Não', value: false },
			],
			listOfIsSowport: [
				{ label: 'Prime', value: true },
				{ label: 'Sowport', value: true },
			],
			listOfIncludeActions: [
				{ label: 'Sim', value: true },
				{ label: 'Não', value: false },
			],
			filter: {
				date: {
					start: '',
					end: '',
					field: '',
				},
				score: {
					min: null,
					max: null,
				},
				processReference: '',
				customerId: null,
				isAnswered: null,
				includeActions: null,
				emailViewed: null,
				isSowport: null,
				teams: [],
			},
			listOfDatesFields: [
				{ label: 'Data de envio', value: 'createdAt' },
				{ label: 'Data da resposta', value: 'answeredAt' },
			],
			tableColumns: [
				{
					label: 'Referência',
					field: 'processReference',
				},
				{
					label: 'Cliente',
					field: 'customerName',
				},
				{
					label: 'Importado por',
					field: 'isSowport',
				},
				{
					label: 'Usuário',
					field: 'userName',
				},
				{
					label: 'Data de envio',
					field: 'createdAt',
					class: 'text-center',
				},
				{
					label: 'E-mail lido',
					field: 'emailViewed',
					class: 'text-center',
				},
				{
					label: 'Respondido',
					field: 'isAnswered',
					class: 'text-center',
				},
				{
					label: 'Nota',
					field: 'score',
					class: 'text-center',
				},
				{
					label: 'Data da resposta',
					field: 'answeredAt',
					class: 'text-center',
				},
				{
					label: 'Observações',
					field: 'observation',
					class: 'text-center',
				},
				{
					label: 'Ações',
					field: 'actions',
					class: 'text-center',
				},
			],
		};
	},
	filters: {
		formatDateTimeFunction(date) {
			if (!date) {
				return '-';
			}
			return moment(date).format('DD/MM/YYYY HH:mm:ss');
		},
	},
	methods: {
		keepOpen(event) {
			event.preventDefault();
			if (event.target && (event.target.tagName === 'A' || event.target.tagName === 'UL')) {
				const dropdowns = document.querySelectorAll('.dropdown-menu');
				dropdowns.forEach((dropdown) => {
					dropdown.classList.remove('show');
				});
			} 
		},
		clearFilter() {
			this.filter = {
				date: {
					start: '',
					end: '',
					field: '',
				},
				score: {
					min: null,
					max: null,
				},
				processReference: '',
				customerId: null,
				isAnswered: null,
				emailViewed: null,
				isSowport: null,
				includeActions: null,
				teams: [],
			};
			this.getDataList(1, this.perPage);
		},
		async findProcessByIdentificationSearch(processReference) {
			const processReferenceNumbersOnly = processReference.toString().replace(/\D/g, '');
			const route = this.$router.resolve(`/operational/imp/desk?showProcess=true&identification=${processReferenceNumbersOnly}`);
			window.open(route.href, '_blank');
		},
		openAnswerModal(id) {
			this.answerModalOpen = true;
			this.answerModalData = this.tableData.content.find(item => item.id === id);
		},
		closeAnswerModal() {
			this.answerModalOpen = false;
			this.answerModalData = {};
			this.npsActionText = '';
		},
		async addNpsAction() {
			const text = (this.npsActionText || '').trim();
			if (!text) {
				Swal.fire('NPS do processo', 'Informe a ação a ser tomada.', 'warning');
				return;
			}
			if (!this.answerModalData.id) return;
			this.$store.commit('setLoading', { show: true, label: 'NPS do processo', description: 'Adicionando ação...' });
			try {
				await Axios.post(
					`${config.env.API_DEFAULT.host}/process-nps/answers/${this.answerModalData.id}/actions`,
					{ description: text }
				);
				this.npsActionText = '';
				Swal.fire('NPS do processo', 'Ação adicionada.', 'success');
				if (this.$refs.npsAnswerTimeline && typeof this.$refs.npsAnswerTimeline.load === 'function') {
					this.$refs.npsAnswerTimeline.load();
				}
				const row = this.tableData.content.find(item => item.id === this.answerModalData.id);
				if (row) {
					this.$set(row, 'countActions', (row.countActions || 0) + 1);
				}
			} catch (err) {
				console.log(err);
				const msg = err.response?.data?.message || 'Não foi possível adicionar a ação.';
				Swal.fire('NPS do processo', msg, 'error');
			} finally {
				this.$store.commit('setLoading', { show: false });
			}
		},
		async getDataList(page = 1, perPage = 20) {
			this.perPage = perPage;
			this.$store.commit("setLoading", {
				show: true,
				label: "Carregando...",
				description: "Recuperando listagem de registros.",
			});
	
			try {
				const params = {
					page: page - 1,
					size: perPage,
				};

				// Mapeamento de filtros para parâmetros da API
				const filterMappings = [
					{
						condition: () => this.filter.date.start && this.filter.date.end && (this.filter.date.field || this.filter.date.field?.value),
						transform: (value) => moment(value).format('YYYY-MM-DD'),
						paramKey: 'startDate',
						value: this.filter.date.start,
					},
					{
						condition: () => this.filter.date.start && this.filter.date.end && (this.filter.date.field || this.filter.date.field?.value),
						transform: (value) => moment(value).format('YYYY-MM-DD'),
						paramKey: 'endDate',
						value: this.filter.date.end,
					},
					{
						condition: () => this.filter.date.start && this.filter.date.end && (this.filter.date.field || this.filter.date.field?.value),
						transform: (value) => value,
						paramKey: 'periodDate',
						value: this.filter.date.field?.value,
					},
					{
						condition: () => this.filter.score.min !== null && this.filter.score.min !== undefined,
						transform: (value) => value,
						paramKey: 'minScore',
						value: this.filter.score.min,
					},
					{
						condition: () => this.filter.score.max !== null && this.filter.score.max !== undefined,
						transform: (value) => value,
						paramKey: 'maxScore',
						value: this.filter.score.max,
					},
					{
						condition: () => this.filter.customerId?.id,
						transform: (value) => value,
						paramKey: 'customerId',
						value: this.filter.customerId?.id,
					},
					{
						condition: () => this.filter.isAnswered?.value === true || this.filter.isAnswered?.value === false,
						transform: (value) => value,
						paramKey: 'answered',
						value: this.filter.isAnswered?.value,
					},
					{
						condition: () => this.filter.emailViewed?.value === true || this.filter.emailViewed?.value === false,
						transform: (value) => value,
						paramKey: 'emailViewed',
						value: this.filter.emailViewed?.value,
					},
					{
						condition: () => this.filter.isSowport?.value === true || this.filter.isSowport?.value === false,
						transform: (value) => value,
						paramKey: 'isSowport',
						value: this.filter.isSowport?.value,
					},
					{
						condition: () => this.filter.processReference,
						transform: (value) => value,
						paramKey: 'processIdentification',
						value: this.filter.processReference,
					},
					{
						condition: () => this.filter.teams.length > 0,
						transform: (value) => value,
						paramKey: 'teamsIds',
						value: this.filter.teams.map(team => team.id).join(','),
					},
					{
						condition: () => this.filter.includeActions?.value === true || this.filter.includeActions?.value === false,
						transform: (value) => value,
						paramKey: 'includeActions',
						value: this.filter.includeActions?.value,
					},
				];

				// Aplicar filtros válidos aos parâmetros
				filterMappings.forEach(({ condition, transform, paramKey, value }) => {
					if (condition()) {
						params[paramKey] = transform(value);
					}
				});

				const response = await Axios.get(`${config.env.API_DEFAULT.host}/process-nps/requests`, { params });
				this.tableData = response.data.data;
			} catch (e) {
				console.log(e);
				Swal.fire({
					title: "Cadastros Operacionais",
					text: "Erro ao listar os registros!",
					type: "error",
				});
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
		async getCustomers() {
			Axios.get(
				`${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
			).then((response) => {
				this.listOfCustomers = response.data._embedded.companies;
			});
		},
		getScoreClass(score) {
			if (score === 1) {
				return 'nps-score-red';
			} else if (score <= 3) {
				return 'nps-score-orange';
			} else if (score <= 6) {
				return 'nps-score-yellow';
			} else if (score <= 8) {
				return 'nps-score-green-light';
			} else {
				return 'nps-score-green-dark';
			}
		},
		getScoreClassification(score) {
			if (score == null || score === undefined) {
				return 'Não informado';
			}
			if (score <= 6) {
				return 'Detrator';
			} else if (score <= 8) {
				return 'Neutro';
			} else {
				return 'Promotor';
			}
		},
		getScoreColor(score) {
			if (score === 1) {
				return '#dc3545';
			} else if (score <= 3) {
				return '#fd7e14';
			} else if (score <= 6) {
				return '#ffc107';
			} else if (score <= 8) {
				return '#28a745';
			} else {
				return '#198754';
			}
		},
		validateScoreInput(type) {
			const value = this.filter.score[type];
			if (value === null || value === undefined || value === '') {
				return;
			}
			const numValue = Number(value);
			if (isNaN(numValue)) {
				this.filter.score[type] = null;
				return;
			}
			if (numValue < 1) {
				this.filter.score[type] = 1;
			} else if (numValue > 10) {
				this.filter.score[type] = 10;
			} else {
				this.filter.score[type] = Math.floor(numValue);
			}
		},
		filterProcessReference(event) {
			// Remove todos os caracteres que não são números
			this.filter.processReference = event.target.value.replace(/\D/g, '');
		},
		onlyNumbers(event) {
			// Permite apenas números (0-9) e teclas de controle (backspace, delete, etc)
			const char = String.fromCharCode(event.which);
			if (!/[0-9]/.test(char) && !event.ctrlKey && !event.metaKey) {
				event.preventDefault();
			}
		},
		getTeams() {
			Axios.get(`${config.env.API_DEFAULT.host}/teams`).then((response) => {
				this.listOfTeams = response.data._embedded.teams;
			});
		},
	},
	mounted() {
		this.getDataList();
		this.getCustomers();
		this.getTeams();
	},
}
</script>

<style scoped>
.registration-title {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1rem;
	flex-wrap: wrap;
	margin-bottom: 1rem;
}

.registration-form {
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-gap: 15px;
	align-content: start;
}

.registration-form .field-error {
	padding: 0.25rem;
	color: var(--danger);
}

.crm-button.add-contact {
	background-color: #1b84e7;
}
.crm-button.add-contact:hover {
	background-color: #5b93d3;
	color: white;
}
.text-color-primary {
	color: var(--header-text-color-hover);
}

.nps-process-link {
	color: var(--header-text-color-hover);
	text-decoration: underline;
	cursor: pointer;
	transition: color 0.2s ease;
}

.nps-process-link:hover {
	color: #1b84e7;
	text-decoration: underline;
}

.registrations-container {
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	background-color: white;
	height: calc(100vh - 105px);
	overflow: hidden;
}

.registrations-main {
	padding: 1.25rem 0.75rem;
	grid-column: span 12;
	overflow: auto;
}

/* Botão de visualizar resposta */
.nps-view-button {
	border-radius: 50% !important;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
}

/* Estilos para tags de score NPS */
.nps-score-red,
.nps-score-orange,
.nps-score-yellow,
.nps-score-green-light,
.nps-score-green-dark {
	min-width: 40px;
	text-align: center;
}

.nps-score-red {
	background-color: #dc3545 !important;
	color: #ffffff !important;
}

.nps-score-orange {
	background-color: #fd7e14 !important;
	color: #ffffff !important;
}

.nps-score-yellow {
	background-color: #ffc107 !important;
	color: #ffffff !important;
}

.nps-score-green-light {
	background-color: #28a745 !important;
	color: #ffffff !important;
}

.nps-score-green-dark {
	background-color: #198754 !important;
	color: #ffffff !important;
}

.nps-score-empty {
	background-color: #e9ecef !important;
	color: #6c757d !important;
	min-width: 40px;
	text-align: center;
}

/* Estilos do Modal de Resposta */
.nps-modal-content {
	display: flex;
	gap: 24px;
	font-family: Helvetica, Arial, sans-serif;
	font-size: 16px;
	line-height: 24px;
	color: #424651;
	padding: 0px 24px;
}

.nps-modal-column {
	min-width: 0;
}

.nps-modal-column-left {
	flex: 0 0 520px;
	border-right: 1px solid #dee2e6;
	padding-right: 24px;
}

.nps-modal-column-right {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.nps-modal-action-card {
	padding: 16px;
	background-color: #f8f9fa;
	border-radius: 8px;
	border: 1px solid #e9ecef;
}

.nps-modal-action-title {
	margin: 0 0 12px 0;
	font-weight: bold;
	font-size: 14px;
	color: #1C3B70;
}

.nps-modal-action-textarea {
	width: 100%;
	padding: 10px 12px;
	margin-bottom: 12px;
	font-size: 14px;
	font-family: inherit;
	border: 1px solid #dee2e6;
	border-radius: 6px;
	resize: vertical;
	box-sizing: border-box;
}

.nps-modal-action-textarea:focus {
	outline: none;
	border-color: #1C3B70;
}

.nps-modal-action-btn {
	margin: 0;
}

/* Score Card */
.nps-modal-score-card {
	margin-bottom: 24px;
}

.nps-modal-score-card-inner {
	padding: 20px;
	background-color: #e9ecef;
	border-radius: 8px;
	text-align: center;
}

.nps-modal-score-label {
	margin: 0 0 8px 0;
	font-size: 14px;
	color: #666666;
}

.nps-modal-score-number {
	margin: 0;
	font-size: 48px;
	font-weight: bold;
	line-height: 1;
}

.nps-modal-score-classification {
	margin: 8px 0 0 0;
	font-size: 16px;
	font-weight: bold;
	color: #424651;
}

/* Details */
.nps-modal-details {
	margin-bottom: 24px;
}

.nps-modal-detail-item {
	padding: 12px 0;
	border-bottom: 1px solid #e9ecef;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.nps-modal-detail-item:last-child {
	border-bottom: none;
}

.nps-modal-detail-label {
	color: #1C3B70;
	font-weight: bold;
}

.nps-modal-detail-value {
	float: right;
	color: #424651;
}

/* Observation */
.nps-modal-observation-section {
	margin-bottom: 24px;
}

.nps-modal-observation-title {
	margin: 0 0 8px 0;
	font-weight: bold;
	color: #1C3B70;
}

.nps-modal-observation-box {
	padding: 16px;
	background-color: #f8f9fa;
	border-left: 4px solid #1C3B70;
	border-radius: 0 4px 4px 0;
}

.nps-modal-observation-text {
	margin: 0;
	font-style: italic;
	color: #424651;
	white-space: pre-wrap;
	word-wrap: break-word;
	line-height: 1.6;
}

.btn-refresh {
  display: flex;
  flex: 0 0 45px;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 2px solid var(--header-text-color-hover);
  color: var(--primary-bg-header);
  cursor: pointer;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  transition: all .2s ease-in-out 0s;
  cursor: pointer;
}

.btn-refresh:hover {
  background: var(--header-text-color-hover);
}

.crm-button {
	min-width: 140px;
	white-space: nowrap;
}

.crm-button.nps-view-button {
	min-width: auto;
}

.crm-button.nps-view-button.nps-view-button-gray {
	background-color: #868ba1;
	border-color: #868ba1;
	color: #fff;
}

.crm-button.nps-view-button.nps-view-button-gray:hover {
	background-color: #5a6268;
	border-color: #545b62;
	color: #fff;
}

.dropdown-demo .dd-link>div span {
	margin-right: 0px !important;
}

</style>
